import React, { useState, useEffect } from "react";
import { loadingService } from '../../services/helpers/loading.service';

export const Loading = (props) => {
    const [obsLoading, setObsLoading] = useState({});

    useEffect(() => {
        loadingService.observable.subscribe(x => {
            setObsLoading(x);
        })
    }, []);

    return (<>
        {obsLoading.show && <LoadingHelper text={obsLoading.text} />}
    </>);
};

const LoadingHelper = (props) => {

    return (
        <div>
            <div className="k-overlay k-loading-overlay"></div>
            <div className="k-loading-container">
                <img src={"/images/loading.gif"} className="k-loading-img" alt={"REGINA MARIA"} />
                {props.text && <span className="k-loading-txt">{props.text}</span>}
            </div>
        </div>
    );
};